import { useProductMeta } from '@websrc/Basket/useProductMeta'
import { CSProductDetails } from '@websrc/Typings/ContentStack'
import React from 'react'

import { ProductInfoPrice } from '../Details/ProductInfo/Price/ProductInfoPrice'

export function ComparisonTableProductPrice({
  product,
  className,
}: {
  product: CSProductDetails
  className: string
}) {
  const productDetails = { ...useProductMeta(product.product_number), ...product }

  return (
    <ProductInfoPrice
      className={className}
      productDetails={{
        is_retired: productDetails.is_retired,
        price_list: productDetails.price_list,
        price_discount: productDetails.price_discount,
      }}
      show={true}
      textSize={'xl2'}
    />
  )
}
